
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/preview/industries/[slug]",
      function () {
        return require("private-next-pages/preview/industries/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/preview/industries/[slug]"])
      });
    }
  